import { Injectable } from '@angular/core';
import { ApiService, HttpMethod } from '../api/api.service';
import { Manager, ManagerHousehold, ManagerHouseholdsResponse } from './manager-households.model';
import { User, GetUsersResponse } from '../users/users.service';

@Injectable({
  providedIn: 'root'
})
export class ManagerHouseholdsService {
  private readonly baseUrl = 'manager-households';

  constructor(private apiService: ApiService) { }

  async getHouseholdManagers(householdId: number): Promise<Manager[]> {
    const response = await this.apiService.call<{ data: { managers: Manager[] } }>(HttpMethod.GET, `${this.baseUrl}/household/${householdId}/managers`);
    return response.data.managers;
  }

  async assignManagerToHousehold(managerId: number, householdId: number): Promise<ManagerHousehold> {
    const body = { MANAGER_ID: managerId, HOUSEHOLD_ID: householdId };
    return this.apiService.call<ManagerHousehold>(HttpMethod.POST, this.baseUrl, body);
  }

  async unassignManagerFromHousehold(managerId: number, householdId: number): Promise<void> {
    return this.apiService.call<void>(HttpMethod.DELETE, `${this.baseUrl}/${managerId}/${householdId}`);
  }

  async getAllManagers(name?: string): Promise<User[]> {
    const params = new URLSearchParams();
    params.append('role', 'MANAGER');
    if (name) {
      params.append('name', name);
    }
    const response = await this.apiService.call<GetUsersResponse>(HttpMethod.GET, `users?${params.toString()}`);
    return response.users;
  }

  async getManagerHouseholds(managerId: number, limit: number = 25, offset: number = 0): Promise<ManagerHouseholdsResponse> {
    const params = new URLSearchParams();
    params.append('limit', limit.toString());
    params.append('offset', offset.toString());
    const response = await this.apiService.call<ManagerHouseholdsResponse>(HttpMethod.GET, `${this.baseUrl}/manager/${managerId}?${params.toString()}`);
    return response;
  }
}
